// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lhsLag{position:relative;padding:25px 0}.lhsLag:not(:last-of-type){border-bottom:"unit(--itemsDividerWidth, px)" solid "color(--itemsDividerColor)"}.YYoFWN{display:flex;align-items:center;margin-bottom:20px}.bu32TS{margin-right:13px}.HMNg6D{margin-right:0;margin-left:13px}.m_pN5l{display:flex;margin-bottom:35px;align-items:center;color:"color(--linkColor)"}.m_pN5l.qsEfN3 .mDjdRG{margin-left:10px;margin-right:0}.m_pN5l.qsEfN3 .mDjdRG.czTP8g{transform:rotate(-135deg)}.mDjdRG{width:6px;height:6px;border-left:1px solid "color(--linkColor)";border-bottom:1px solid "color(--linkColor)";transform:rotate(-135deg);transition:0.1s transform;margin-left:auto;margin-right:4px;position:relative}.mDjdRG.eweuar{top:1px;transform:rotate(135deg)}.mDjdRG.czTP8g{margin-left:0;transform:rotate(45deg);margin-right:10px}.iJndv8{margin-right:auto;margin-left:0;transform:rotate(45deg)}.BWZlIZ{color:#f15347}.kFrc39:after{content:"\\200E‎"}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardRowContainer": `lhsLag`,
	"header": `YYoFWN`,
	"icon": `bu32TS`,
	"iconRTL": `HMNg6D`,
	"iconRtl": `HMNg6D`,
	"arrowContainer": `m_pN5l`,
	"rtl": `qsEfN3`,
	"arrow": `mDjdRG`,
	"arrowBack": `czTP8g`,
	"expanded": `eweuar`,
	"arrowRTL": `iJndv8`,
	"arrowRtl": `iJndv8`,
	"expired": `BWZlIZ`,
	"rtm": `kFrc39`
};
export default ___CSS_LOADER_EXPORT___;
